import MediaReleasesView from "./MediaReleasesView";

export default MediaReleasesView;
